<template>
  <div class="container pt-mb-5 pt-3 mb-sm-5 mb-3">
    <div class="dashboard">
      <div class="row mt-5">
        <div class="col-lg-3 col-md-4 mb-5">
          <div class="sidebar">
            <a href="#">
              <h3 class="ser-vis-head dasssh">Dashboard</h3>
            </a>
            <ul>
              <li>
                <a :href="myProfileRoute" class="hover-color"><img :src="image1" class="iamgdd1" />User Profile</a>
              </li>
              <li>
                <a :href="petData" class="hover-color"><img :src="image2" class="iamgdd1" />My Pets</a>
              </li>
              <li class="prof-3">
                <a href="" class="my_booking hover-color"><img :src="image3" class="iamgdd1" />My Bookings</a>
              </li>
              <li>
                <a :href="logoutRoute" class="hover-color"><img :src="image4" class="iamgdd1" />Logout</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9 col-md-8 mb-5">
          <div class="d-flex justify-content-between">
            <div>
              <h3 class="text-primary">{{ bookingId }}</h3>
              <h5 class="my_booking_head">Pet Videos and Images</h5>
            </div>
            <div>
              <button class="btn btn-primary" @click="goBack">
                <i class="fas fa-arrow-left"></i> Back
              </button>
            </div>
          </div>
          <div v-if="computedData && Object.keys(computedData).length === 0" class="no-data">
            <p>No videos or images uploaded yet.</p>
            <!-- <img :src="`${webBaseUrl}/path-to-your-placeholder-image.png`" alt="No media uploaded" class="img-fluid" /> -->
          </div>

          <div v-else>
            <div v-for="(mediaItems, date) in computedData" :key="date" class="album-section mb-4">
              <h4 class="mb-3">{{ date }}</h4>
              <div class="row">
                <div v-for="(media, index) in mediaItems" :key="index" class="col-md-4 mb-4">
                  <template v-if="media.file_type.startsWith('image/')">
                    <img :src="`${webBaseUrl}/${media.file_path}`" :alt="'Image ' + index" class="img-fluid rounded shadow-sm" @click="openModal(media)" style="cursor: pointer; aspect-ratio: 4 / 3; object-fit: cover" />
                  </template>
                  <template v-else-if="media.file_type.startsWith('video/')">
                    <div class="ratio ratio-4x3 rounded shadow-sm" style="cursor: pointer" @click="openModal(media)">
                      <video :src="`${webBaseUrl}/${media.file_path}#t=0.5`" style="width: 100%; height: 100%; object-fit: cover"></video>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showModal" class="modal d-block" @click="closeModal" style="background-color: rgba(0, 0, 0, 0.7)">
            <div class="modal-dialog modal-dialog-centered modal-lg" @click.stop>
              <div class="modal-content">
                <!-- <span class="close position-absolute end-0 mt-2 me-3 fs-2" @click="closeModal" style="cursor: pointer">&times;</span> -->
                <div class="modal-header">
                  <h5 class="modal-title">
                    {{ formattedModalDate }}
                  </h5>

                  <button type="button" class="btn-close" @click="closeModal"></button>
                </div>

                <div class="modal-body mb-3 pb-0 text-center" style="max-height: 80vh; overflow-y: auto">
                  <template v-if="currentMedia.file_type.startsWith('image/')">
                    <img :src="`${webBaseUrl}/${currentMedia.file_path}`" class="img-fluid rounded" />
                  </template>
                  <template v-else-if="currentMedia.file_type.startsWith('video/')">
                    <video :src="`${webBaseUrl}/${currentMedia.file_path}`" controls class="w-100 rounded"></video>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="spring-img">
    <img :src="image1" />
  </div>

  <div class="spring-img-2">
    <img :src="image2" />
  </div> -->
</template>

<script setup>
import { ref, computed } from 'vue'

const { mediasData, bookingsData, bookingId, baseUrl, petData, logoutRoute, myBookings, myProfileRoute, image1, image2, image3, image4 } = defineProps(['mediasData', 'bookingsData', 'bookingId', 'baseUrl', 'petData', 'logoutRoute', 'myProfileRoute', 'myBookings', 'image1', 'image2', 'image3', 'image4'])

const showModal = ref(false)
const currentMedia = ref({})

console.log("My Bookings ",myBookings);

const openModal = (media) => {
  currentMedia.value = media
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
  currentMedia.value = {}
}

const goBack = () => {
  window.location.href = myBookings
}

const computedData = computed(() => {
  return mediasData
})

const formattedModalDate = computed(() => {
  if (!currentMedia.value.date) return ''
  const date = new Date(currentMedia.value.date)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}-${month}-${year}`
})

const webBaseUrl = computed(() => {
  return baseUrl
})

const comoutedBookingsData = computed(() => {
  return bookingsData
})
</script>

<style scoped>
/* .dashboard {
  display: flex;
  margin: 0 auto;
} */

/* gallery start */

.album-section {
  margin-bottom: 50px;
}

.album-section h4 {
  color: #495057;
  margin-bottom: 20px;
  font-weight: bold;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 10px;
}

.album-section .gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.album-section .gallery-item {
  flex: 1 1 calc(33.333% - 20px);
  /* 3 items per row with gaps */
  max-width: calc(33.333% - 20px);
  position: relative;
  overflow: hidden;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.album-section .gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.album-section .gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.album-section .gallery-item:hover img {
  transform: scale(1.05);
}

/* Ensures that gallery items maintain a consistent square aspect ratio */

/* .album-section .gallery-item::after {
  content: "";
  display: block;
  padding-bottom: 100%;
} */

@media (max-width: 768px) {
  .album-section .gallery-item {
    flex: 1 1 calc(50% - 20px);
    /* 2 items per row for medium screens */
    max-width: calc(50% - 20px);
  }
}

@media (max-width: 576px) {
  .album-section .gallery-item {
    flex: 1 1 100%;
    /* 1 item per row for small screens */
    max-width: 100%;
  }
}

/* gallery end */

.sidebar {
  max-width: 100%;
  padding: 20px;
  top: 48px;
  border-radius: 10px;
  position: static;
  box-shadow: none !important;
  background: #f8f8f8;
}

.sidebar h2 {
  margin-bottom: 20px;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar ul li {
  margin-bottom: 10px;
  padding: 10px 15px;
}

.sidebar ul li a {
  text-decoration: none;
  color: #2e2928;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

/* .sidebar ul li a:hover {
  color: #bf360c;
} */

.main-content {
  flex: 1;
  /* padding: 20px; */
  margin-left: 0px !important;
  background-color: white;
  border-radius: 10px;
  /* margin-top: 40px; */
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  border: 1px solid #ececec;
}

.stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stat-card {
  flex: 1;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  text-align: center;
}

.order-list {
  list-style: none;
  padding: 0;
}

.order-list li {
  margin-bottom: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  display: flex;
  justify-content: space-between;
}

.clos-btn {
  color: #000;
  background-color: #ffff !important;
  border-radius: 10px;
}

.add-new-btns {
  color: black;
  background: transparent;
}

.add-new-btns:hover {
  color: white;
  background-color: #bf360c;
}

.my_booking {
  color: #bf360c !important;
}

.my_booking_head {
  font-size: 20px;
  font-weight: 600;
  color: #2e2928;
  margin-bottom: 20px;
  /* border-bottom: 1px dashed #bf360c; */
  /* padding-bottom: 20px; */
}

.web-bg {
  position: relative;
}

.spring-img {
  position: absolute;
  bottom: 20px;
  left: -40px;
}

.spring-img img {
  width: 150px;
}

.spring-img-2 img {
  width: 130px;
}

.spring-img-2 {
  position: absolute;
  top: 30px;
  right: 0;
}

.sidebar ul li a.active {
  color: #bf360c !important;
}

.iamgdd1 {
  width: 30px;
  margin-right: 10px;
}

.sidebar ul li:hover {
  background-color: #f9ede8;
  border-radius: 20px;
}

.prof-3 {
  background-color: #f9ede8 !important;
  border-radius: 20px;
  margin-bottom: 10px;
}

.sidebar ul li:hover .hover-color {
  color: #bf360c !important;
}

.middle {
  border-bottom: 1px dashed #ececec !important;
}

.table tbody tr td {
  border-bottom: 1px dashed #ececec !important;
}

.table_resposive {
  border-radius: 10px 10px 0px 0px;
}

/* media css */

@media screen and (max-width: 1600px) {
  .spring-img-2 img {
    display: none;
  }

  .spring-img img {
    display: none;
  }
}

@media screen and (max-width: 1199px) {
  /* .sidebar {
    height: 250px;
  } */
}

@media screen and (max-width: 991px) {
  .table_resposive {
    display: block;
    width: 100%;
    overflow-x: auto;
  }
}

@media screen and (max-width: 767px) {
  .web-bg .sidebar {
    height: auto !important;
  }

  .web-bg .main-content {
    margin-top: 20px;
  }
}

.pagination-controls {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}

.pagination-controls button {
  margin: 0 10px;
}
</style>
